import React, { useEffect, useState } from 'react'
import { Image } from 'react-native'
import { environment } from '@/main/config/env'
import { useImage, useThemeClient } from '@/presentation/hooks'

type LogoThemeProps = {
  height?: number
  width?: number
}

export const LogoTheme: React.FC<LogoThemeProps> = ({ width = 60, height = 24 }) => {
  const { getImage } = useImage()
  const { getThemeClient } = useThemeClient()
  const [logoEmpresa, setLogoEmpresa] = useState('')

  const themeClient = getThemeClient()
  const logoInside = environment === 'production' && logoEmpresa
    ? { uri: logoEmpresa }
    : require('../../../../assets/logo-white.svg')

  useEffect(() => {
    themeClient.imageLogo && environment === 'production' &&
      getImage(themeClient.imageLogo, 'logo')
        .then(logo => { setLogoEmpresa(logo) })
        .catch(console.error)
  }, [])

  return (
    <Image
      style={{
        width,
        height,
        marginRight: 8
      }}
      resizeMode='contain'
      source={logoInside}
    />
  )
}
